import {Category, DiscountManager, Item, ItemGroup, OrderItem, Store} from 'aigens-ng-core';
import {ChangeDetectorRef, Component, Injector, OnInit} from '@angular/core';
import {RouteTable} from '../../../core/route-table';
import {getDeliveryDelayTime, getPickupDelayTime} from '../../../shared/utilities/checkFormatTool';
import {ByodSummaryPage} from '../../summary/byod-summary/byod-summary';
import {getSetLayout} from '../../../shared/utilities/layout-helper';
import {ComboPage} from '../../item/combo-page/combo-page';
import {SideBarModifierDialog} from 'src/app/dialogs/sideBarModifier/sideBarModifier';
import {BaseCartPage} from '../../../core/base/base-cart-page';
import {SdkAlipayHKService} from '../../../core/services/sdk-alipay-hk-service';
import {SdkNativeOepayService} from '../../../core/services/sdk-native-oepay-service';
import {SdkApplepayService} from '../../../core/services/sdk-applepay-service';
import {SdkWeChatPayService} from '../../../core/services/sdk-wechat-pay-service';
import {DatePipe} from '@angular/common';
import {MultiStepComboPage} from '../../item/multi-step-combo/multi-step-combo-page.component';

import {AddressDialog} from 'src/app/dialogs/address-dialog/address-dialog.component';

declare var gtag;


@Component({
    selector: 'cart-scroll-page',
    templateUrl: 'cart-scroll-page.html',
    styleUrls: ['cart-scroll-page.scss']
})
export class CartScrollPage extends BaseCartPage implements OnInit {
    static _this: CartScrollPage;

    isEdit = false;

    // promoGift
    promoGiftLock = false;

    deleteItemIndex = 999;
    addItemIndex = 999;
    newAddIndex = -1;
    // delivery
    courier: any;
    shipping = 0;

    // tslint:disable-next-line: max-line-length
    constructor(public discountManager: DiscountManager, public sdkWeChatPayService: SdkWeChatPayService, public sdkAlipayHKService: SdkAlipayHKService, public sdkNativeOepayService: SdkNativeOepayService, public sdkApplePayService: SdkApplepayService, injector: Injector, public datePipe: DatePipe, private cd: ChangeDetectorRef) {

        super(injector);
        CartScrollPage._this = this;
    }

    selectAddress() {
        console.log('selectAddress');
        this.courier = null;
        this.addressManagerService.currentCourier = null;
        this.shipping = 0;
        this.popUpAdressModal({
            addAddressCb: () => {
                this.popUpAdressModal({orderItems: this.orderManager.order.orderitems}); // in order to after adding address successly but the modal is close and can not to select currentAddress
            }
        });
    }

    async popUpAdressModal(params) {
        let modal = await this.modalController.create(
            {
                component: AddressDialog,
                componentProps: params,
                showBackdrop: true,
                backdropDismiss: false,
                cssClass: ''
            });

        modal.onDidDismiss().then((data) => {

        });
        modal.present().then(() => {
            //  cb()
        });
    }


    clickEdit() {
        this.isEdit = !this.isEdit;
    }


    ngOnInit() {
        super.ngOnInit();
        console.log('CartScrollPage ngOnInit', this.orderManager.order);
        
        // flag control for show order q
        this.orderManager.mode === 'delivery' && this.genDeliveryOrder();
        if (this.systemConfigService.showOrderQueueInCart) {
            this.checkFirebaseStoreOrders();
        }

    }

    genDeliveryOrder() {
        this.shipping = 0;
        let {currentAddress, currentCourier} = this.addressManagerService;
        if (!currentAddress) {
            this.showAlert('fial', 'please select address first');
            return;
        }
        if (currentCourier) {
            this.addressManagerService.calculateAddress(currentAddress, this.orderService.store, this.order.orderitems, currentCourier.id).subscribe(result => {
                this.loading(false);
                this.shipping = result.shipping;
                // this.order.gr;
            }, err => {
                this.loading(false);
                return this.showAlert(err.status, err['error']);
            });

        } else {
            this.shipping = 0; // no couriter no shipping
        }
    }

    ionViewDidEnter() {
        this.checkModifiableItems();
        this.orderManager.mode === 'delivery' && this.genDeliveryOrder();
        console.log('ionViewDidEnter() : orderItems', this.orderManager.order.orderitems);
    }

    isSet(oi: OrderItem) {
        // sometimes combo-oi because of the oi.category.groups is [],so return false
        return oi.combo || OrderItem.isSet(oi);
    }

    modifierClicked(oi: OrderItem) {
        let oiId = oi.categoryId;
        let store = this.orderManager.getStore(oi.storeId);
        let nowCategory: Category[] = oi.categoryType !== 'recommendation' ? store.categories.filter((category) => category.id === oiId) : [store.menu.recommendation];
        let oiItemId = oi.groups[0].items[0].id;
        // tslint:disable-next-line:no-var-keyword
        let nowItem = nowCategory[0].groups[0].items.filter((item) => item.id === oiItemId);
        // tslint:disable-next-line:no-var-keyword
        var groups = nowCategory[0].groups,
            groups = groups && groups.filter(group => {
                return this.menuManager.isAvailableGroup(
                    store, nowCategory[0], group, oi.takeout, Date.now(), false);
            });
        this.add(nowItem[0], groups[0], oi, false);
    }

    handlingModifier(oi: OrderItem, item: Item, itemMap, addHandler: any, notAddHandler: any, showLastOne: boolean = false) {
        let group = oi.groups[0];
        if (true) {
            this.presentModifierPopup(this.orderManager.getStore(oi.storeId), oi, group, itemMap, SideBarModifierDialog, (confirm) => {
                if (confirm && confirm['data']) {
                    addHandler();
                }
            }, showLastOne);
        } else {
            addHandler();
        }
    }

    removeClicked(item: Item) {
        console.log('remove clicked');
        this.orderManager.minusItem(item, true);
    }

    async presentModifierPopup(store: Store, orderItem: OrderItem, group: ItemGroup, itemMap: any, page: any, handler?: any, showLastOne?: boolean) {
        // let options = {showBackdrop: true, backdropDismiss: true, cssClass: 'modal-largescreen'};
        const input = {store: store, orderitem: orderItem, group: group, itemMap: itemMap, side: true};
        if (showLastOne) {
            input['showLastOne'] = showLastOne;
        }
        const modal = await this.modalController.create({
            component: page,
            componentProps: input,
            animated: true,
            showBackdrop: false,
            backdropDismiss: true,
            cssClass: 'modal-largescreen modifier-modal sidebar-modal-backdrop-dismiss'
        });
        modal.onDidDismiss().then((confirm) => {
            if (handler) {
                handler(confirm);
            }
        });
        modal.present();
    }

    paymentHandling() {
        const payMethods = this.getPaymentMethods(this.payments);

        const size = Object.keys(payMethods).length;
        const hideHistory = this.settings ? this.settings.hideHistory : false;

        console.log('size', size);
        const payLater = this.orderManager.mode === 'byod' || this.orderManager.mode === 'prekiosk';

        if (size >= 1 && !payLater) {
            let charge = (this.store && this.store.menu && this.store.menu.serviceCharge) || 0;
            console.log('charge:', charge);

            if (this.sdkNativeOepayService.isAvailable() && payMethods['oepay']) {
                this.pushByName('OepayPaymentPage', {
                    order: this.orderManager.getOrder(),
                    payment: payMethods['oepay'],
                    hideHistory: hideHistory
                });

            } else if (this.selectedPoint === this.order.grandTotal && this.selectedPoint !== 0 && charge === 0) {

                console.log('free order:', this.selectedPoint);

                let creditCardCharge = this.payments.find(p => {
                    if (p && p.method === 'creditcard') {
                        return true;
                    }
                });

                console.log('ppp:', creditCardCharge);
                if (creditCardCharge) {
                    let order_ = this.genOrder(this.orderManager.getOrder());
                    order_.grandTotal = this.orderManager.getNetAmount();
                    order_.usedPoints = Number(this.selectedPoint);

                    this.pushByName('MpgsHostSessionPage', {
                        order: this.orderManager.getOrder(),
                        payment: creditCardCharge,
                        hideHistory: hideHistory,
                        store: this.orderManager.store,
                        pointsPay: true
                    }, {relativeTo: this.route});
                    // this.postFreeOrder(order_,creditCardCharge);
                } else {
                    this.showAlert('missing credit card payment', null);
                }


            } else {
                this.paymentConfirmAlert(payMethods);

            }

        } else {


            this.cartService.lockSharingCart().then(data => {
                console.log('on lock callback', data);
                if (!data || !data['committed']) {

                    this.toastController.create({
                        message: ' someone is submitting current order, please wait',
                        duration: 2000,
                        position: 'middle'
                    }).then(modal => {
                        modal.present();
                    });
                    return;
                } else {
                    this.loading(true);
                    const order = this.orderManager.getOrder();
                    if (this.orderManager.mode === 'prekiosk') {
                        const endTime = new Date();
                        endTime.setHours(Number(this.orderService.currentPeriod.endTime.split(':')[0]), Number(this.orderService.currentPeriod.endTime.split(':')[1]), 0, 0);
                        order.expire = endTime.getTime();
                    }

                    this.orderService.postOrder(this.orderManager.getOrder()).subscribe(
                        order => {
                            this.loading(false);
                            console.log('order', order);

                            // this.orderService.order = order;
                            let hasNewOffer = false;

                            if (order.newOffers && order.newOffers.length > 0) {
                                hasNewOffer = true;
                            }

                            this.cartService.unlockSharingCart();
                            // this.popToRoot();
                            this.popToRoot().then(temp => {
                                this.navController.setDirection('root');
                                if (hideHistory) {
                                    this.pushByUrl(RouteTable['OrderStatusPage'], {status: 'success', hideHistory: true}, {});
                                } else {
                                    if (order.type === 'prekiosk') {
                                        this.pushByUrl(RouteTable['OrderStatusPreKioskPage'], {
                                            order: order,
                                            fromCart: true,
                                            store: this.orderManager.store
                                        }).then(() => {
                                            this.orderService.clear();
                                            this.orderManager.clear();
                                            // if (this.getNavParams('fromSplash')) {
                                            //     this.orderManager.clear();
                                            // }
                                        });
                                    } else if (order.type === 'byod') {
                                        this.pushByUrl(RouteTable['OrderStatusPage'], {
                                            status: 'success',
                                            storeId: this.orderManager.store.id,
                                            spot: this.orderService.spot,
                                            key: this.orderService.session,
                                            hideHistory: false,
                                            hasNewOffer: hasNewOffer
                                        }, {}).then(() => {
                                            this.orderService.clear();
                                            if (this.getNavParams('fromSplash')) {
                                                this.orderManager.clear();
                                            }
                                        });
                                    }

                                }
                            });


                        },
                        err => {
                            this.loading(false);
                            if (err.status === 599) {


                                const alert = this.showAlert(err.status, err['_body'], [{
                                    text: this.t.instant('buttons.ok'),
                                    handler: () => {
                                        this.pushByName('ByodSummaryPage');
                                    }
                                }]);

                            } else {
                                this.showError(err);
                            }
                        },
                        () => {
                            this.cartService.unlockSharingCart();
                        }
                    );
                }
            }, () => {
            });

        }
    }

    async paymentConfirmAlert(payMethods: any) {
        // const alert = await this.alertController.create({
        //     header: this.t.instant('pages.cart.confirm'),
        //     buttons: [
        //         {
        //             text: this.t.instant('buttons.cancel'),
        //             role: 'cancel',
        //             handler: data => {
        //             }
        //         },
        //         {
        //             text: this.t.instant('buttons.ok'),
        //             handler: data => {
        //                 this.presentPaymentMethod(payMethods);
        //             }
        //         }
        //     ],
        //         cssClass: "AQA-confirmPayment"
        // });
        // alert.present();
        this.presentPaymentMethod(payMethods);
    }

    selectUpSelling(item: Item) {
        if (item.groupIds.length > 0) {
            let page = getSetLayout(this.orderManager.store.menu.setLayout);
            const groups = [];
            item.groupIds.forEach((groupId) => {
                groups.push(this.orderManager.store.menu['gmap'][groupId]);
            });
            item.groups = groups;
            // this.pushByUrl(page, {
            //     store: this.orderManager.store,
            //     category: this.upSellItemCategory,
            //     groups: [this.upSellItemGroup],
            //     item: item,
            //     upSelling: true
            // }, {relativeTo: this.route});

            let params = {
                store: this.orderManager.store,
                category: this.upSellItemCategory,
                groups: [this.upSellItemGroup],
                item: item,
                upSelling: true
            };
            let cssClass = 'modal-largescreen combo-modal-backdrop-dismiss';
            this.navToAssignLayoutItems(page === 'MultiStepComboPage' ? MultiStepComboPage : ComboPage, page, params, {}, cssClass);


        } else {

            if (this.checkStoreMaxItem()) {
                this.showStoreMaxItemAlert();
                return;
            }

            this.orderManager.addSingleItem(this.upSellItemCategory, this.upSellItemGroup, item, false);
            
            this.applyPromotion();
        }
        this.checkModifiableItems();
    }

    // 增加 orderItem 数量
    addClicked(oi: OrderItem) {
        this.googleAnalyticEventTrack('add', 'open edit');
        // this.orderService.addExistingOrderItem(oi);
        if (this.checkStoreMaxItem()) {
            this.showStoreMaxItemAlert();
            return;
        }
        this.orderManager.addExistingOrderItem(oi);
        this.applyPromotion();
    }

    // 复制 orderItem when it is combo(isSet()==true)
    duplicateClicked(oi: OrderItem, oiIndex: number) {

        // this.orderService.addOrderItem(oi);
        // this.orderService.addSet(oi.category, oi.groups, oi.items);
        // var newOi = this.orderService.copyOrderItem(oi);
        // this.orderService.addOrderItem(newOi);
        this.googleAnalyticEventTrack('duplicate', 'open edit');

        if (this.checkStoreMaxItem()) {
            this.showStoreMaxItemAlert();
            return;
        }

        this.addItemIndex = oiIndex;

        setTimeout(() => {
            this.orderManager.duplicateOrderItem(oi);
            this.newAddIndex = oiIndex + 1;
            this.resetAddItemIndex();
            this.applyPromotion();
            // resort the orderItems
            let orderItems = this.orderManager.order.orderitems;
            let lastOi = orderItems[orderItems.length - 1];
            orderItems = orderItems.slice(0, orderItems.length - 1);
            orderItems.splice(oiIndex + 1, 0, lastOi);
            this.orderManager.order.orderitems = orderItems;

        }, 300);

    }

    // 删除 orderitem when it is combo(isSet()==true)
    deleteClicked(oi: OrderItem, oiIndex: number) {

        this.deleteItemIndex = oiIndex;
        this.googleAnalyticEventTrack('delete', 'open edit');

        // this.orderService.minusOrderItem(oi);

        setTimeout(() => {
            this.orderManager.minusOrderItem(oi);
            this.resetDeleteItemIndex();
            // TODO: this.navController.canGoBack()=> this.stackController.canGoBack(0)?
            if (this.orderManager.isEmpty()) {
                this.navigationService.popPage();
            } else {
                this.applyPromotion();
            }
        }, 300);

    }

    promoGiftCheck() {
        this.promoGiftLock = false;
        if (this.applyDiscountCode(this.discountCode)) {
            this.showToast(this.t.instant('pages.cart.discount-code-fail'), 2000, 'top', 'error-alert');
        }
    }

    async showPromoGift() {
        this.promoGiftLock = true;
        /////////////////// 下面的code是以alert形式出现///////////////////
        // const alert = await this.alertController.create({
        //     header: this.t.instant('pages.cart.input-discount-code'),
        //     inputs: [{
        //         name: 'discountCode',
        //         type: 'text',
        //         label: this.t.instant('pages.cart.input-discount-code'),
        //         value: ''
        //     }],
        //     buttons: [
        //         {
        //             text: this.t.instant('buttons.cancel'),
        //             handler: () => {
        //             }
        //         },
        //         {
        //             text: this.t.instant('buttons.ok'),
        //             handler: ({discountCode}) => {
        //                 this.discountCode = discountCode;
        //                 if (this.applyDiscountCode(discountCode)) {
        //                     this.showToast(this.t.instant('pages.cart.discount-code-fail'), 2000, 'top', 'error-alert');
        //                     return false;
        //                 }
        //             }
        //         }
        //     ]
        // });
        // await alert.present();
    }

    // 减少 当前 orderItem 的 数量
    minusClicked(oi: OrderItem, oiIndex: number) {

        this.deleteItemIndex = oiIndex;
        this.googleAnalyticEventTrack('minus', 'open edit');

        let timer = oi && oi.quantity === 1 ? 500 : 0;

        setTimeout(() => {
            // this.orderService.minusOrderItem(oi);
            this.orderManager.minusOrderItem(oi);

            this.resetDeleteItemIndex();

            // TODO: this.navController.canGoBack()=> this.stackController.canGoBack(0)?
            if (this.orderManager.isEmpty()) {
                this.orderService.clearPromoCodeGift();
                this.orderManager.setDiscountCode(''); // 清空discountCode
                this.navigationService.popPage();
            } else {
                this.applyPromotion();
            }
        }, timer);


    }

    async editClicked(oi: OrderItem) {
        console.log('edit clicked', oi);
        this.googleAnalyticEventTrack('edit', 'open edit');
        const category = oi.category;
        const mainItem: Item = oi.items[0];

        let componentProps = {
            store: this.orderManager.store,
            edit: oi,
            category,
            groups: category.groups,
            item: mainItem

        };
        let page = getSetLayout(this.orderManager.store.menu.setLayout);
        let cssClass = 'modal-largescreen combo-modal-backdrop-dismiss';

        this.navToAssignLayoutItems(page === 'MultiStepComboPage' ? MultiStepComboPage : ComboPage, page, componentProps, {
            relativeTo: this.route,  // replaceUrl: true,
            skipLocationChange: false
        }, cssClass);

    }

    getDefaultTimeLabel(): string {
        let timeDelay;
        if (this.orderManager.mode !== 'delivery') {
            timeDelay = getPickupDelayTime(this.orderManager.store);
        } else {
            timeDelay = getDeliveryDelayTime(this.orderManager.store);
        }
        // return timeDelay > 0 ? (timeDelay + this.t.instant('global.minutes-later')) : this.t.instant('global.eat-now');
        return timeDelay > 0 ? (timeDelay + this.t.instant('global.minutes-later')) : this.t.instant('global.eat-now');
    }

    isValidPickupTime(): boolean {
        const currentTime = new Date().getTime();
        if (this.pickedTimeNum > currentTime || this.timelabel === this.getDefaultTimeLabel()) {
            return true;
        } else {
            this.orderService.pickUpLabel = null;
            if (!this.orderService.isCourt) {
                this.orderService.pickUpTime = null;
            } // 如果是court pickupTime采取页面开始时选择的Time
            this.settingPickupTimeDisplay();
            this.settingPickupTime();
            this.showAlert('', this.t.instant('global.pick-up-time-invalid'));
            return false;
        }
    }

    public pageName(): string {
        return '/cart';
    }


    private resetDeleteItemIndex() {
        this.deleteItemIndex = 999;
    }

    private resetAddItemIndex() {
        this.addItemIndex = 999;
        setTimeout(() => {
            this.newAddIndex = -1;
        }, 1000);
    }


}
